import React, { useRef, useState } from "react";
import StyleInfo from "../../../BookModule.module.css";
import createInfo from "../IndividualBook/IndividualBookInfoCreate.module.css";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import ViewIcon from "../../BookTabs/ViewIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Search } from "@mui/icons-material";
import { AxiosInstance } from "../../../../../../../axios";
import { R_PER_PAGE } from "../../../../../../../labels";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useEffect } from "react";
import BookSetInfo from "../../../BookModule.module.css";
import Select from "react-select";
import { customStyles } from "../../../../../../../pages/customStyles";
import moment from "moment";
import { ImageUrlPrefix } from "../../../../../../../labels";
import { Download } from "@mui/icons-material";
import Loader from "../../../../../Loader";
import toast from "react-hot-toast";
import Creatable from "react-select/creatable";
import {
  clearFreeBookredux,
  resetSaveSelectedBooks,
  saveSelectedBooks,
  setFreeBookredux,
} from "../../../../../../../redux/CreateBooksetSlice";
import {
  clearBookFilters,
  setBookFilters,
} from "../../../../../../../redux/purchaseBookFilterSlice";

export default function CreateBookSet() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseURL = AxiosInstance.defaults.baseURL;
  const isFirstRender = useRef(true);
  const filterRef_mrp = useRef(null);
  const [freeBook, setFreeBook] = useState(0);
  // user details
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  // List data load table
  let page = R_PER_PAGE;
  let filterSearch = [];
  let filterAuthor = [];
  let filterPublisher = [];
  let filtervisible_to_user = [];
  let filterCategory = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterMedium = [];
  let filterSeries = [];
  const filterRef_author = useRef(null);
  const filterRef_publisher = useRef(null);
  const filterRef_visible_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_series = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_subject = useRef(null);
  const filterRef_medium = useRef(null);
  const txtBSearch_sub = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const txtBSearch_course = useRef(null); //search icon
  const tagsGrouping_ref = useRef(null);
  const seriesTag_ref = useRef(null);
  const [tagsList, setTagsList] = useState("");
  const category_ref = useRef(null);
  const course_ref = useRef(null);
  const subject_ref = useRef(null);
  const medium_ref = useRef(null);
  const isbn_ref = useRef(null);
  const youtube_ref = useRef(null);
  const upload_image_ref = useRef(null);
  const bookset_name_ref = useRef(null);
  const description_ref = useRef(null);
  const offerPer_ref = useRef(null);
  const visible_ref = useRef(null);

  // use state
  const [error, setError] = useState({});
  const [images, setImages] = useState([]);
  const [imageURLS, setImageURLs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [updateListData, setUpdateListData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [courseIds, setCourseIds] = useState([]);
  const [auData, setAuData] = useState([]);
  const [pubData, setPubData] = useState([]);
  const [author_name, setAuthor_name] = useState([]);
  const [publisher_name, setPublisher_name] = useState([]);
  const [visible_to_user, setVisible_to_user] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [series_on, setSeries_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [isOpen, setIsOpen] = useState({
    author: false,
    publisher: false,
    visible_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    price: false,
  });

  const [mrp, setMrp] = useState({
    fromDate: "",
    toDate: "",
  });
  const [initialfields, setInitialfields] = useState({
    visible: "",
    book_title: "",
    // author: [],
    authorGrouping: "",
    authorLabel: "",
    publisherLabel: "",
    publisheGrouping: "",
    tagsGrouping: "",
    tagsLabel: "",
    isbnNumber: "",
    tnoPage: "",
    answersheet_path: "",
    iframe: "",
    bookPathUrl: "",
    description: "",
    stockCount: "",
    price: "",
    mediumGrouping: "",
    offer_percentage: "",
    category: "",
    course: "",
    subject: "",
    medium: "",
    length: "",
    width: "",
    thickness: "",
    weight: "",
    // tags: "",
    categoryGrouping: "",
    CategoryTypeLabel: "",
    courseGrouping: "",
    CourseTypeLabel: "",
    subjectGrouping: "",
    subjectTypeLabel: "",
    upload_image_path: [],
    upload_image_original_path: "",
    upload_image_id: "",
    tagLine: "",
    seriesGrouping: "",
    seriesTypeLabel: "",
    is_combo_offer: 0,
  });
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_author.current &&
        !filterRef_author.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "author"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "author"
            );
            setAuthor_name(updatedAuthor);
          } else {
            setAuthor_name([]);
          }
          setIsOpen((prev) => ({ ...prev, author: false }));
        }
      }
      if (
        filterRef_publisher.current &&
        !filterRef_publisher.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "publisher"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "publisher"
            );
            setPublisher_name(updatedCategory);
          } else {
            setPublisher_name([]);
          }
          setIsOpen((prev) => ({ ...prev, publisher: false }));
        }
      }
      if (
        filterRef_visible_to_user.current &&
        !filterRef_visible_to_user.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "visible_to_user"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "visible_to_user"
            );
            setVisible_to_user(updatedCategory);
          } else {
            setVisible_to_user([]);
          }
          setIsOpen((prev) => ({ ...prev, visible_to_user: false }));
        }
      }
      if (
        filterRef_category.current &&
        !filterRef_category.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_course.current &&
        !filterRef_course.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
      if (
        filterRef_series.current &&
        !filterRef_series.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "seriesTag"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "seriesTag"
            );
            setSeries_on(updatedCategory);
          } else {
            setSeries_on([]);
          }
          setIsOpen((prev) => ({ ...prev, seriesTag: false }));
        }
      }

      if (
        filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            const [fromDate, toDate] = updatedAuthor[0].name
              .split(" - ")
              .map((val) => val.trim());
            setMrp({ fromDate, toDate });
          } else {
            // alert("2")
            setMrp({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }
      // if (filterRef_ebook.current &&
      //   !filterRef_ebook.current.contains(event.target)) {
      //   {
      //     const hasCategory = updateChipData.some(
      //       (chipItem) => chipItem.type === "eBook"
      //     );
      //     if (hasCategory) {
      //       const updatedCategory = updateChipData.filter(
      //         (chipItem) => chipItem.type === "eBook"
      //       );
      //       setEBook(updatedCategory);
      //     } else {
      //       setEBook([]);
      //     }
      //     setIsOpen((prev) => ({ ...prev, is_ebook: false }));
      //   }
      // }

      // if (filterRef_freeBook.current &&
      //   !filterRef_freeBook.current.contains(event.target)) {
      //   {
      //     const hasCategory = updateChipData.some(
      //       (chipItem) => chipItem.type === "freeBook"
      //     );
      //     if (hasCategory) {
      //       const updatedCategory = updateChipData.filter(
      //         (chipItem) => chipItem.type === "freeBook"
      //       );
      //       setFreeBook(updatedCategory);
      //     } else {
      //       setFreeBook([]);
      //     }
      //     setIsOpen((prev) => ({ ...prev, is_free_book: false }));
      //   }
      // }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    author_name,
    publisher_name,
    series_on,
    visible_to_user,
    category_on,
    course_on,
    subject_on,
    medium_on,
    freeBook,
    mrp,
  ]);
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/findById", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          const bookData = res.data.data;
          setFreeBook(bookData.is_free_book); // This triggers another useEffect

          setInitialfields({
            book_title: bookData.book_title,
            author: bookData.author,
            publisher: bookData.publisher,
            isbn_no: bookData.isbn_no,
            price: bookData.price,
            is_combo_offer: bookData.is_combo_offer,
            offer_percentage: bookData.offer_percentage,
            finalPrice: bookData.finalPrice,
            isbnNumber: res.data.data.isbn_no,
            description: bookData.description,
            stock_count: bookData.stock_count,
            CategoryTypeLabel: bookData.category_name,
            categoryGrouping: bookData.category_id,
            CourseTypeLabel: bookData.group_course_name,
            courseGrouping: bookData.group_course_id,
            subjectGrouping: bookData.subject_id,
            subjectTypeLabel: bookData.subject_name,
            mediumTypeLabel: bookData.medium,
            mediumGrouping: bookData.medium_id,
            seriesGrouping: bookData.series_id,
            seriesTypeLabel: bookData.series_name,
            visible: bookData.is_visible,
            tagsLabel: bookData.tags.map((item) => item.tag_name),
            tagsGrouping: bookData.tags.map((item) => item.tag_id),
            weight: bookData.weight,
            tagLine: bookData.tag_line,
            tnoPage: bookData.total_pages,
            iframe: extractIframeSrc(bookData.iframe),
            dimension: bookData.dimension,
            bookPathUrl: bookData.ebook_url,
            preview_path: bookData.preview_path,
            original_preview_path: bookData.original_preview_path,
            ebook: bookData.is_ebook,
            upload_image_original_path: bookData.images.map(
              (item) => item.original_book_image_path
            ),
            // upload_image_path: bookData.images.map(
            //   (item) => item.book_image_path
            // ),
            upload_image_path: res.data.data.images.map((item) => ({
              path: item.book_image_path,
              originalname: item.original_book_image_path,
              image_id: item.image_id,
              is_valid: 1,
              isFromAPI: true,
            })),
            upload_image_id: bookData.images.map((item) => item.image_id),
          });
          const updatedBooks = res.data.set_book.map((book, index) => ({
            ...book,
            seriesNumber: index + 1,
          }));

          setSelectedBooks(updatedBooks);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }, []);
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);
  useEffect(() => {
    if (freeBook !== 0) {
      loadListdata();
    }
  }, [freeBook]);

  const navigateToPreviousScreen = () => {
    dispatch(resetSaveSelectedBooks());
    dispatch(clearBookFilters());
    dispatch(clearFreeBookredux());
    navigate(-1); // Navigate back by one step in the history
  };

  const [rowsPerPageTwo, setRowsPerPageTwo] = useState(5);
  const [currentPageTwo, setCurrentPageTwo] = useState(1);

  const totalPagesTwo = Math.ceil(selectedBooks?.length / rowsPerPageTwo);

  const handlePageCountTwo = (e) => {
    const newRowsPerPage = Number(e.target.value);
    setRowsPerPageTwo(newRowsPerPage);
    setCurrentPageTwo(1);
  };

  const handlePrevTwo = () => {
    setCurrentPageTwo((prev) => Math.max(prev - 1, 1));
  };

  const handleNextTwo = () => {
    setCurrentPageTwo((prev) => Math.min(prev + 1, totalPagesTwo));
  };

  const startIndex = (currentPageTwo - 1) * rowsPerPageTwo;
  const endIndex = startIndex + rowsPerPageTwo;
  const paginatedBooks = selectedBooks?.slice(startIndex, endIndex);

  const [category, setCategory] = useState();
  const [groupName, setGroupName] = useState();
  const [subjectGroupName, setSubjectGroupName] = useState();
  const handleChange = (event) => {
    let { name, files, value } = event.target;
    // if (name === "description") {
    //   value = value.replace(/^['"]+|['"]+$/g, "");
    // }
    if (name === "uploadPrevImage") {
      if (files && files.length > 0) {
        const selectedFiles = Array.from(files);
        const oversizedFiles = selectedFiles.filter(
          (file) => file.size > 2 * 1024 * 1024
        );

        if (oversizedFiles.length > 0) {
          const fileNames = oversizedFiles.map((file) => file.name).join(", ");
          setError((prevState) => ({
            ...prevState,
            upload_image_path: `The following image(s) exceed 2MB: ${fileNames}. Please ensure each image is less than 2MB.`,
          }));
          return;
        }

        const existingValidImages =
          initialfields.upload_image_path?.filter(
            (image) => image.is_valid !== 0
          ) || [];
        const totalFiles = existingValidImages.length + selectedFiles.length;

        if (totalFiles > 4) {
          setError((prevError) => ({
            ...prevError,
            upload_image_path: "Please upload up to 4 images",
          }));
          return;
        }

        const formData = new FormData();
        selectedFiles.forEach((file) => {
          formData.append("book_image", file);
        });

        AxiosInstance.post("api/upload/", formData)
          .then((res) => {
            const newImages = res.data.path.map((item) => ({
              path: item.path,
              originalname: item.originalname,
              is_valid: 1,
              isFromAPI: false, // ✅ Mark as new image
            }));

            setInitialfields((prevState) => ({
              ...prevState,
              upload_image_path: [
                ...(prevState.upload_image_path || []),
                ...newImages,
              ],
              upload_image_original_path: [
                ...(prevState.upload_image_original_path || []),
                ...res.data.path.map((item) => item.originalname),
              ],
            }));

            setError((prev) => ({
              ...prev,
              upload_image_path: "",
            }));
          })
          .catch(() => {
            setError((prev) => ({
              ...prev,
              upload_image_path: "Error uploading images",
            }));
          });

        // Reset file input so re-uploading same file triggers onChange
        event.target.value = null;
      }
    }
    // else if (name === "isbnNumber") {
    //   const regex = /^(?:\d{10}|\d{13})$/; // Match exactly 10 or 13 digits
    //   if (regex.test(value)) {
    //     setInitialfields((prevFields) => ({
    //       ...prevFields,
    //       [name]: value,
    //     }));
    //     setError({
    //       ...error,
    //       [name]: "", // Clear error when valid
    //     });
    //   } else {
    //     setInitialfields((prevFields) => ({
    //       ...prevFields,
    //       [name]: value, // Allow user to type while checking validity
    //     }));
    //     setError({
    //       ...error,
    //       [name]: "ISBN number must be either 10 or 13 digits",
    //     });
    //   }
    // }
    else if (name === "offer_percentage") {
      const regex = /^[0-9]{1,2}$/; // Match 1 to 5 digits only (no negative numbers)
      if (regex.test(value)) {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "", // Clear error when valid
        });
      } else {
        setError({
          ...error,
          [name]:
            "Only PDF files are allowed. Please upload a valid PDF under 10 MB ",
        });
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value, // Allow user to type while checking validity
        }));
        if (value < 0) {
          setError({
            ...error,
            [name]: "Value cannot be negative",
          });
        } else if (value.length > 1) {
          setError({
            ...error,
            [name]: "Value cannot exceed 2 digits",
          });
        } else {
          setError({
            ...error,
            [name]: "Please enter a valid number between 0 and 100",
          });
        }
      }
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setMrp((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const [preOrderItem, setPreOrderItem] = useState([]);

  const [selectedBookItem, setSelectedBookItem] = useState([]);

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    filterAuthor = author_name;
  }, [author_name]);

  useEffect(() => {
    filterPublisher = publisher_name;
  }, [publisher_name]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterCourse = course_on;
  }, [course_on]);
  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);
  useEffect(() => {
    filterSeries = series_on;
  }, [series_on]);
  useEffect(() => {
    filtervisible_to_user = visible_to_user;
  }, [visible_to_user]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    AxiosInstance.get("api/course/getGroupCourse")
      .then((res) => {
        const groupCourse = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setGroupName(groupCourse);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // useEffect(() => {
  //   const courseList = {
  //     type: initialfields.categoryGrouping,
  //     group_course_id: initialfields.courseGrouping,
  //   };
  //   AxiosInstance.post("api/all/getSubjects_groupname", courseList)
  //     .then((res) => {
  //       const groupSubject = res.data?.data?.map((item, index) => ({
  //         value: item.id,
  //         label: item.subject,
  //       }));
  //       setSubjectGroupName(groupSubject);
  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // }, [initialfields.categoryGrouping, initialfields.courseGrouping]);

  useEffect(() => {
    const search = "";
    AxiosInstance.post("api/book/tag/list", search)
      .then((res) => {
        const tags = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.tag_name,
        }));
        setTagsList(tags);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };
  const [selectedBookSort, setSelectedBookSort] = useState("asc");

  const SortSelectedBooks = (event, sortKey) => {
    event.preventDefault();

    let order = selectedBookSort === "asc" ? "desc" : "asc";
    setSelectedBookSort(order);

    let sortedList = selectedBooks.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setSelectedBooks(sortedList);
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "author") {
      if (checked) {
        setAuthor_name([{ id: value, name: name, type: "author" }]);
      } else {
        setAuthor_name(author_name.filter((item) => item.id !== value));
      }
    } else if (typename === "publisher") {
      if (checked) {
        setPublisher_name([{ id: value, name: name, type: "publisher" }]);
      } else {
        setPublisher_name(publisher_name.filter((item) => item.id !== value));
      }
    } else if (typename === "visible_to_user") {
      if (checked) {
        setVisible_to_user([
          { id: value, name: name, type: "visible_to_user" },
        ]);
      } else {
        setVisible_to_user(visible_to_user.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([{ id: value, name: name, type: "category" }]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([{ id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([{ id: value, name: name, type: "subject" }]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "seriesTag") {
      if (checked) {
        setSeries_on([
          ...series_on,
          { id: value, name: name, type: "seriesTag" },
        ]);
      } else {
        setSeries_on(series_on.filter((item) => item.id !== value));
      }
    }
  };
  const [originalListData, setOriginalListData] = useState();
  const [originalListDataPub, setOriginalListDataPub] = useState();
  const [originalListDataCourse, setOriginalListDataCourse] = useState();
  const [originalListDataSubject, setOriginalListDataSubject] = useState();
  const filteredCourseData = courseIds.filter(
    (item) => item.course_id && item.course_id !== 0
  );

  const uniqueCourse = Array.from(
    new Map(filteredCourseData.map((item) => [item.course_id, item])).values()
  );

  const filteredSubjectData = subjectIds.filter(
    (item) => item.subject_id && item.subject_id !== 0
  );
  const uniqueSubject = Array.from(
    new Map(filteredSubjectData.map((item) => [item.subject_id, item])).values()
  );

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenAuthorIds = new Set();
      const seenPublisherIds = new Set();
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const auDatas = data
        .filter((es) => {
          if (seenAuthorIds.has(es.author_id)) {
            return false; // Skip this entry if the author_id is already seen
          } else {
            seenAuthorIds.add(es.author_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          author_name: es.author,
          author_id: es.author_id,
        }));

      setAuData(auDatas);
      const uniqueAuthors = Array.from(
        new Map(
          auDatas
            ?.filter((item) => item.author_id !== 0) // Remove items with author_id = 0
            .map((item) => [item.author_id, item])
        ).values()
      );

      setOriginalListData(uniqueAuthors);
      const PublishDatas = data
        .filter((es) => {
          if (seenPublisherIds.has(es.publisher_id)) {
            return false;
          } else {
            seenPublisherIds.add(es.publisher_id);
            return true;
          }
        })
        .map((es) => ({
          publisher_name: es.publisher,
          publisher_id: es.publisher_id,
        }));

      setPubData(PublishDatas);

      const filteredPubData = PublishDatas.filter(
        (item) => item.publisher_id && item.publisher_id !== 0
      );
      const uniquePublishers = Array.from(
        new Map(
          filteredPubData.map((item) => [item.publisher_id, item])
        ).values()
      );
      setOriginalListDataPub(uniquePublishers);

      const CourseDatas = data
        .filter((es) => {
          if (seenCourseIds.has(es.group_course_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);

      // setOriginalListDataCourse(uniqueCourse);

      const SubjectDatas = data
        .filter((es) => {
          if (seenSubjectIds.has(es.subject_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);

      // const filteredSubjectData = subjectIds.filter(
      //   (item) => item.subject_id && item.subject_id !== 0
      // );
      // const uniqueSubject= Array.from(
      //   new Map(
      //     filteredSubjectData.map((item) => [item.subject_id, item])
      //   ).values()
      // );
      // setOriginalListDataSubject(uniqueSubject);
    }
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    if (mrp.fromDate || mrp.toDate) {
      tempArr.push({
        name: ` ${mrp.fromDate || 0} - ${mrp.toDate || 0}`,
        value: `MRP`,
        type: "price",
      });
    }
    filterAuthor.map((obj) => {
      tempArr.push(obj);
    });
    filtervisible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterPublisher.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterSeries.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  function updateStateData() {
    filterAuthor = author_name;
    filterPublisher = publisher_name;
    filtervisible_to_user = visible_to_user;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterSeries = series_on;
    filterMedium = medium_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "author") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        author: false,
      });
    } else if (name === "publisher") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        publisher: false,
      });
    } else if (name === "visible_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        visible_to_user: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "seriesTag") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        seriesTag: false,
      });
    } else if (name === "price") {
      loadChipdata();

      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleClear = (name, event) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      author: false,
      publisher: false,
      visible_to_user: false,
      category: false,
      course: false,
      subject: false,
      medium: false,
      seriesTag: false,
      is_ebook: false,
      is_free_book: false,
    });
    if (name === "author") {
      setAuthor_name([]);
      filterAuthor = [];
    } else if (name === "publisher") {
      setPublisher_name([]);
      filterPublisher = [];
    } else if (name === "visible_to_user") {
      setVisible_to_user([]);
      filtervisible_to_user = [];
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "course") {
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "seriesTag") {
      setSeries_on([]);
      filterSeries = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "price") {
      setMrp({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleAllClear = () => {
    setAuthor_name([]);
    setPublisher_name([]);
    setVisible_to_user([]);
    setMrp({});
    setSubject_on([]);
    setMedium_on([]);
    setSeries_on([]);
    setCourse_on([]);
    setSearchTerm("");
    filterSearch = [];
    setCategory_on([]);
    setUpdateChipData([]);
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "author") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        author: !prevState.author, // Toggle the value
        visible_to_user: false,
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
      }));
      setAuthor_name(updateChipData.filter((ui) => ui.type === "author"));
    } else if (boxName === "publisher") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: false,
        publisher: !prevState.publisher, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setPublisher_name(updateChipData.filter((ui) => ui.type === "publisher"));
    } else if (boxName === "visible_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: !prevState.visible_to_user, // Toggle the value
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setVisible_to_user(
        updateChipData.filter((ui) => ui.type === "visible_to_user")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "seriesTag") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        seriesTag: !prevState.seriesTag, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: false,
        is_free_book: false,
        medium: false,
      }));
      setSeries_on(updateChipData.filter((ui) => ui.type === "seriesTag"));
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    }
  };

  const handlechangeSelectDropdown = (selectedOptions, dname) => {
    if (dname === "authorGrouping") {
      const isNew = selectedOptions.__isNew__;
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: isNew ? "" : selectedOptions.value,
        ["authorLabel"]: selectedOptions.label,
        // ...(isNew && { name: "", id: "" }),
      }));
      setError({
        ...error,
        [dname]: "",
      });
    } else if (dname === "publisheGrouping") {
      const isNew = selectedOptions.__isNew__;
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: isNew ? "" : selectedOptions.value,
        ["publisherLabel"]: selectedOptions.label,
        // ...(isNew && { name: "", id: "" }),
      }));
      setError({
        ...error,
        [dname]: "",
      });
    } else if (dname === "tagsGrouping") {
      if (selectedOptions) {
        // const selectedLabels = selectedOptions.map((option) => option.label);
        const selectedLabels = selectedOptions.map((option) => option.label);
        const selectedValues = selectedOptions.map((option) =>
          option.__isNew__ ? "" : option.value
        );
        if (selectedLabels.length > 8) {
          setError({
            ...error,
            [dname]: "You can only select a maximum of 8 tags",
          });
        } else {
          setInitialfields((prevState) => ({
            ...prevState,
            [dname]: selectedValues,
            ["tagsLabel"]: selectedLabels,
            // ...(isNew && { name: "", id: "" }),
          }));
          setError({
            ...error,
            [dname]: "",
          });
        }
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["tagsLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "categoryGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["CategoryTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["CategoryTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "courseGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["CourseTypeLabel"]: selectedOptions.label,
          ["subjectGrouping"]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["CourseTypeLabel"]: "",
          ["subjectGrouping"]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "subjectGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["subjectTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "mediumGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["mediumTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["mediumTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "seriesGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["seriesTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["seriesTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "publisher") {
      setPublisher_name(
        publisher_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterPublisher = publisher_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "price") {
      setInitialfields({ fromDate: "", toDate: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "price")
      );
      shouldReloadChipData = false;
    } else if (chipToDelete.type === "visible_to_user") {
      setVisible_to_user(
        visible_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filtervisible_to_user = visible_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "course") {
      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "seriesTag") {
      setSeries_on(series_on.filter((item) => item.id !== chipToDelete.id));
      filterSeries = series_on.filter((item) => item.id !== chipToDelete.id);
    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };
  // const handleDeleteImg = (indexToDelete) => {
  //   setInitialfields((prevState) => {
  //     const updatedImages = prevState.upload_image_path.map((imageObj, index) =>
  //       index === indexToDelete
  //         ? { ...imageObj, is_valid: 0 } // Mark `is_valid` as 0 for the deleted image
  //         : imageObj
  //     );

  //     return {
  //       ...prevState,
  //       upload_image_path: updatedImages,
  //     };
  //   });
  // };
  const handleDeleteImg = (event, indexToDelete) => {
    event.preventDefault();
    setInitialfields((prevState) => {
      const updatedUploadPaths = [...prevState.upload_image_path];
      const updatedOriginalPaths = [
        ...(prevState.upload_image_original_path || []),
      ];
      const imageToDelete = updatedUploadPaths[indexToDelete];
      if (imageToDelete?.isFromAPI && imageToDelete.image_id) {
        updatedUploadPaths[indexToDelete] = {
          ...imageToDelete,
          is_valid: 0,
        };
      } else {
        updatedUploadPaths.splice(indexToDelete, 1);
        updatedOriginalPaths.splice(indexToDelete, 1);
      }
      return {
        ...prevState,
        upload_image_path: updatedUploadPaths,
        upload_image_original_path: updatedOriginalPaths,
      };
    });
  };
  const categories = [
    { value: "upsc", label: "UPSC" },
    { value: "tnpsc", label: "TNPSC" },
    { value: "Banking", label: "Banking" },
    { value: "rrb", label: "RRB" },
    { value: "trb", label: "TRB" },
    { value: "tet", label: "TET" },
    { value: "tnusrb", label: "TNUSRB" },
    { value: "ssc", label: "SSC" },
    { value: "others", label: "Others" },
  ];
  const course = [];
  const subject = [];
  const medium = [
    { value: "tamil", label: "Tamil" },
    { value: "english", label: "English" },
  ];
  const tags = [];
  // Handle checkbox change
  const updateSerialNumbers = (books) => {
    return books.map((book, index) => ({
      ...book,
      serialNumber: index + 1, // Assign sequential serial numbers
    }));
  };
  const filters = useSelector((state) => state.listBookFilter);
  const { freeBookredux } = useSelector((state) => state.books);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  useEffect(() => {
    if (freeBookredux !== null) {
      setFreeBook(freeBookredux);
    }
  }, [freeBookredux]);
  useEffect(() => {
    setAuthor_name(filters.author || []);
    setPublisher_name(filters.publisher || []);
    setVisible_to_user(filters.visibleToUser || []);
    setCategory_on(filters.category || []);
    setCourse_on(filters.course || []);
    setSubject_on(filters.subject || []);
    setMedium_on(filters.medium || []);
    setSeries_on(filters.seriesTag || []);
    setSearchTerm(filters.searchTerm || []);
    setMrp(filters.price || {});
    setIsFiltersInitialized(true); // Mark filters as initialized
    // setInitialfields({
    //   weight: filters.weight,
    //   price: filters.totalPrice
    // })
    setInitialfields((prev) => ({
      ...prev,
      weight: filters.weight,
      price: filters.totalPrice,
    }));

    const allFilters = [
      ...(filters.author || []),
      ...(filters.publisher || []),
      ...(filters.visibleToUser || []),
      ...(filters.category || []),
      ...(filters.course || []),
      ...(filters.subject || []),
      ...(filters.medium || []),
      ...(filters.seriesTag || []),
      ...(filters.eBook || []),
      ...(filters.price?.fromDate && filters.price?.toDate
        ? [
            {
              name: `${filters.price.fromDate} - ${filters.price.toDate}`,
              type: "price",
            },
          ]
        : []),
      ...(typeof filters.searchTerm === "string" &&
      filters.searchTerm.trim() !== ""
        ? [{ name: filters.searchTerm, type: "search" }]
        : []),
    ];
    setUpdateChipData(allFilters);
  }, [filters]);

  useEffect(() => {
    if (
      isFiltersInitialized &&
      filters &&
      Object.keys(filters).some((key) => filters[key]?.length > 0)
    ) {
      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (isFiltersInitialized && filters) {
      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  const reduxSelectedBooks = useSelector(
    (state) => state?.books?.selectedBooks || []
  );

  useEffect(() => {
    setSelectedBooks(reduxSelectedBooks);
  }, [reduxSelectedBooks]);
 const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, [pathname]);
  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch(resetSaveSelectedBooks());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleView = (ids) => {
    dispatch(saveSelectedBooks(selectedBooks));
    dispatch(
      setBookFilters({
        author: author_name,
        publisher: publisher_name,
        visibleToUser: visible_to_user,
        category: category_on,
        course: course_on,
        subject: subject_on,
        medium: medium_on,
        seriesTag: series_on,
        searchTerm: searchTerm,
        price: initialfields,
      })
    );
    dispatch(setFreeBookredux(freeBook));
    navigate(`/viewIndividualBook/${ids}`);
  };

  const handleChangeBookOrder = (e, bookId) => {
    setSelectedBooks((prev) => {
      let updatedBooks;
      if (e.target.checked) {
        const bookToAdd = currentData.find((book) => book.id === bookId);
        if (!bookToAdd) return prev;

        updatedBooks = [...prev, bookToAdd].map((book, index) => ({
          ...book,
          seriesNumber: index + 1, //  Assigns sequential numbering
        }));
      } else {
        updatedBooks = prev
          .filter((book) => book.id !== bookId)
          .map((book, index) => ({
            ...book,
            seriesNumber: index + 1, //  Recalculate series numbers after removal
          }));
      }

      const totalMRP = updatedBooks?.reduce(
        (sum, book) => sum + (book.price || 0),
        0
      );
      const totalWeight = updatedBooks?.reduce(
        (sum, book) => sum + (book.weight || 0),
        0
      );
      const roundedTotalWeight = parseFloat(totalWeight?.toFixed(3));

      setInitialfields((prevFields) => ({
        ...prevFields,
        price: totalMRP,
        weight: roundedTotalWeight,
      }));

      return updatedBooks;
    });
  };

  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.book_title || COMSECFO.book_title.trim() === "") {
      bookset_name_ref.current.focus();
    } else if (!COMSECFO.description) {
      description_ref.current.focus();
    } else if (!COMSECFO.tagsGrouping) {
      tagsGrouping_ref.current.focus();
    }
    //  else if (COMSECFO.seriesGrouping.length === 0) {
    //   seriesTag_ref.current.focus();
    // }
    else if (
      !COMSECFO.upload_image_path ||
      COMSECFO.upload_image_path.filter((img) => img?.is_valid !== 0).length ===
        0
    ) {
      upload_image_ref.current.focus();
    }
    // else if (!COMSECFO.categoryGrouping) {
    //   category_ref.current.focus();
    // }
    else if (!COMSECFO.iframe) {
      youtube_ref.current.focus();
    }
    // else if (!COMSECFO.courseGrouping) {
    //   course_ref.current.focus();
    // } else if (!COMSECFO.subjectGrouping) {
    //   subject_ref.current.focus();
    // } else if (!COMSECFO.mediumTypeLabel) {
    //   medium_ref.current.focus();
    // }
    else if (
      !COMSECFO.isbnNumber ||
      (COMSECFO.isbnNumber?.trim() === "" && COMSECFO.ebook == 0)
    ) {
      isbn_ref.current.focus();
    }
  };
  const validateFields = (data) => {
    const errors = {};
    // const isbnRegex = /^(?:\d{10}|\d{13})$/;
    // if (data.isbnNumber && !isbnRegex.test(data.isbnNumber)) {
    //   errors.isbnNumber = "ISBN number must be either 10 or 13 digits";
    // }
    const offerRegex = /^[0-9]{1,2}$/;
    if (data.offer_percentage && !offerRegex.test(data.offer_percentage)) {
      errors.offer_percentage = "Offer percentage must be between 0 and 100";
    }
    // if (data.iframe === "") {
    //   errors.iframe = "Please enter a valid Youtube URL.";
    // }
    if (!data.book_title || data.book_title.trim() === "") {
      errors.book_title = "Please enter the  bookset name";
    }
    if (data.description === "") {
      errors.description = "Please enter the description";
    }
    if (freeBook === 0) {
      if (data.offer_percentage === "") {
        errors.offer_percentage = " Please enter the offer percentage";
      }
    }

    if (data.offer_percentage && data.offer_percentage > 99) {
      errors.offer_percentage = "Please enter the  valid offer percentage";
    }
    if (data.tagsGrouping.length === 0) {
      errors.tagsGrouping = "Please select or enter new tags";
    }
    // if (data.seriesGrouping?.length === 0 || data.seriesGrouping === null) {
    //   errors.seriesGrouping = "Please select book series";
    // }
    if (
      !data.upload_image_path ||
      data.upload_image_path.filter((img) => img?.is_valid !== 0).length === 0
    ) {
      errors.upload_image_path = "Please upload atleast one image";
    }
    // if (data.categoryGrouping === "") {
    //   errors.categoryGrouping = "Please select a category";
    // }
    // if (data.courseGrouping === "") {
    //   errors.courseGrouping = "Please select a course";
    // }
    // if (data.subjectGrouping === "") {
    //   errors.subjectGrouping = "Please select a subject";
    // }
    // if (data.isbnNumber) {
    //   if (data.isbnNumber.length !== 10 && data.isbnNumber.length !== 13) {
    //     errors.isbnNumber = "ISBN number must be either 10 or 13 digits";
    //   }
    // }
    if (!data.isbnNumber || data.isbnNumber?.trim() === "") {
      errors.isbnNumber = "Please enter the ISBN number";
    }
    // if (data.mediumGrouping === "") {
    //   errors.mediumGrouping = "Please select a medium";
    // }
    validateFocusCommentSection(data);
    return errors;
  };
  const extractIframeSrc = (iframeString) => {
    if (!iframeString) return ""; // If empty, return empty string

    // Extract the src URL from the iframe tag if present
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString; // If match found, return src URL; otherwise, return as-is
  };

  const handleIframeChange = (e) => {
    let value = e.target.value.trim();
    let errorMessage = "";
    // Regex to match:
    // 1. YouTube embed URL (https://www.youtube.com/embed/...)
    // 2. YouTube share URL (https://youtu.be/...)
    // 3. Valid <iframe> tag containing a YouTube embed URL
    const youtubeRegex =
      /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;
    // Validate YouTube URL or iframe tag
    // if (!value) {
    //   errorMessage = "YouTube URL cannot be empty";
    // } else
    if (!youtubeRegex.test(value)) {
      errorMessage = "Please enter a valid YouTube URL";
    } else {
      // If input is a YouTube short URL (youtu.be), convert it to an embed URL
      const youtuMatch = value.match(
        /^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?.*)?$/
      );
      if (youtuMatch) {
        value = `https://www.youtube.com/embed/${youtuMatch[1]}`;
      }
    }

    // Update state
    setInitialfields((prevFields) => ({
      ...prevFields,
      iframe: value,
    }));

    // Update error state
    setError((prev) => ({
      ...prev,
      iframe: errorMessage || undefined, // Remove error if valid
    }));
  };
  const cleanIframeUrl = (iframeString) => {
    if (!iframeString) return "";
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString; // If match found, return extracted src; otherwise, return as-is
  };

  function loadListdata() {
    let tempAuthor = [];
    let tempPublisher = [];
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempVuser = [];
    let tempSeries = [];
    author_name.map((obj) => {
      tempAuthor.push(obj.id);
    });
    publisher_name.map((obj) => {
      tempPublisher.push(obj.id);
    });
    category_on.map((obj) => {
      tempCate.push(obj.id);
    });
    course_on.map((obj) => {
      tempCourse.push(obj.id);
    });
    subject_on.map((obj) => {
      tempSubj.push(obj.id);
    });
    medium_on.map((obj) => {
      tempMedium.push(obj.id);
    });
    visible_to_user.map((obj) => {
      tempVuser.push(obj.id);
    });
    series_on.map((obj) => {
      tempSeries.push(obj.id);
    });
    let statusFilter = {
      is_ebook: "",
      is_free_book: freeBook,
      is_combo_offer: "",
      // book_type: "",
      search: searchTerm.length > 0 ? searchTerm : "",
      author_id: author_name.length > 0 ? tempAuthor : "",
      publisher_id: publisher_name.length > 0 ? tempPublisher : "",
      category_id: category_on.length > 0 ? tempCate : "",
      group_course_id: course_on.length > 0 ? tempCourse : "",
      subject_id: subject_on.length > 0 ? tempSubj : "",
      medium: medium_on.length > 0 ? tempMedium : "",
      is_set: 0,
      start_range_mrp: mrp.fromDate || "",
      end_range_mrp: mrp.toDate || "",
      book_type: series_on.length > 0 ? tempSeries.map(Number) : "",
      visible_user: visible_to_user.length > 0 ? tempVuser : "",
      select_set_list: 1,
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          const FD = res.data.data;
          const serialNumberAddedData = FD.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);

          setIsLoading(false);
        } else {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }

  const handleSubmit = () => {
    const errors = validateFields(initialfields);
    // Validate iframe only if a value is entered
    if (initialfields.iframe.trim()) {
      const youtubeRegex =
        /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;
      // Check if input is just an empty iframe tag or invalid format
      if (
        initialfields.iframe.trim() === "<iframe></iframe>" ||
        !youtubeRegex.test(initialfields.iframe)
      ) {
        errors.iframe = "Invalid YouTube URL";
      }
    }
    if (Object.keys(errors).length === 0) {
      if (selectedBooks.length >= 2) {
        try {
          const bookIdsString = selectedBooks.map((book) => book.id).join(",");
          if (id) {
            // const imagesList = [
            //   ...initialfields.upload_image_path.map((path, index) => ({
            //     id: initialfields.upload_image_id[index] || "", // Empty ID for new images
            //     original_book_image_path:
            //       initialfields.upload_image_original_path[index] || "", // Original path for new images
            //     book_image_path: path.path || path.book_image_path, // Handle both cases
            //     is_valid: path.is_valid ?? 1, // Default to valid if not specified
            //   })),
            // ];
            const activeImages = initialfields.upload_image_path?.filter(
              (img) => img.is_valid !== 0
            );
            const deletedAPIImages = initialfields.upload_image_path
              ?.filter((img) => img.is_valid === 0 && img.isFromAPI)
              .map((img) => ({
                id: img.image_id,
                is_valid: 0,
              }));

            const uploadedImages = activeImages.map((img, index) => ({
              id: img.image_id || "",
              original_book_image_path:
                initialfields.upload_image_original_path?.[index] ||
                img.originalname ||
                "",
              book_image_path: img.path || img.book_image_path,
              is_valid: 1,
            }));

            const imagesList = [...uploadedImages, ...deletedAPIImages];
            // If an id is provided, update the data
            const editData = {
              id: id, // Empty for create, filled for edit
              is_set: 1, // Adjust based on your logic (0 for single book, 1 for bookset)
              book_ids: bookIdsString,
              book_title: initialfields.book_title,
              author_id: 0,
              author_name: initialfields.authorLabel || null,
              publisher_id: 0,
              publisher_name: initialfields.publisherLabel || null,
              isbn_no: initialfields.isbnNumber || "",
              price: parseInt(initialfields.price) || 0,
              offer_percentage: parseInt(initialfields.offer_percentage) || 0,
              stock_count: parseInt(initialfields.stockCount) || 0,
              category_id: initialfields.categoryGrouping || 0,
              category_name:
                selectedBooks
                  ?.map((book) => book.category_name)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  ) // removes null/empty only
                  .join(", ") || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name:
                selectedBooks
                  ?.map((book) => book.group_course_name)
                  .filter(Boolean)
                  .join(", ") || "",
              subject_id: initialfields.subjectGrouping || 0,
              subject_name:
                selectedBooks
                  ?.map((book) => book.subject_name)
                  .filter(Boolean)
                  .join(", ") || null,
              is_free_book: freeBook,
              // is_ebook: 0,
              is_combo_offer: initialfields.is_combo_offer,
              is_free_book: 0,
              medium:
                selectedBooks
                  ?.map((book) => book.medium_id)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  )
                  .join(", ") || "",
              tag_line: initialfields.tagLine,
              book_type:
                selectedBooks
                  ?.map((book) => book.series_id)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  )
                  .join(", ") || "",
              tags:
                initialfields.tagsGrouping.length > 0 &&
                initialfields.tagsGrouping.map((id, index) => ({
                  id,
                  tag_name: initialfields.tagsLabel[index],
                })),
              dimension: null,
              weight: initialfields.weight || null,
              description: initialfields.description || "",
              total_pages: parseInt(initialfields.tnoPage) || 0,
              // iframe: initialfields.iframe || null,
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              ebook_url: initialfields.bookPathUrl,
              is_ebook: 0,
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              is_visible: parseInt(initialfields.visible),
              images: imagesList,
              created_dt: moment().format("YYYY-MM-DD"),
              created_by: userid,
            };

            AxiosInstance.post("/api/book/add", editData)
              .then((res) => {
                if (res.data.status) {
                  toast.success(res.data.message);
                  navigate(-1);
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          } else {
            const images = initialfields.upload_image_path
              ?.filter((img) => img.is_valid !== 0) // ✅ Filter out deleted images
              .map((path, index) => ({
                id: "",
                original_book_image_path:
                  initialfields.upload_image_original_path?.[index] ||
                  path.original_book_image_path ||
                  "",
                book_image_path: path.path || path.book_image_path,
                is_valid: 1,
              }));
            // If no id is provided, add the new data
            const createData = {
              id: "", // Empty for create, filled for edit
              is_set: 1, // Adjust based on your logic (0 for single book, 1 for bookset)
              book_ids: bookIdsString,
              book_title: initialfields.book_title,
              author_id: 0,
              author_name: initialfields.authorLabel || null,
              publisher_id: 0,
              publisher_name: initialfields.publisherLabel || null,
              isbn_no: initialfields.isbnNumber || "",
              is_free_book: freeBook,
              // is_ebook: 0,
              is_combo_offer: initialfields.is_combo_offer,
              price: parseInt(initialfields.price) || 0,
              offer_percentage: parseInt(initialfields.offer_percentage) || 0,
              stock_count: parseInt(initialfields.stockCount) || 0,
              category_id: initialfields.categoryGrouping || 0,
              category_name:
                selectedBooks
                  ?.map((book) => book.category_name)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  ) // removes null/empty only
                  .join(", ") || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name:
                selectedBooks
                  ?.map((book) => book.group_course_name)
                  .filter(Boolean)
                  .join(", ") || "",
              subject_id: initialfields.subjectGrouping || 0,
              subject_name:
                selectedBooks
                  ?.map((book) => book.subject_name)
                  .filter(Boolean)
                  .join(", ") || null,
              tag_line: initialfields.tagLine,
              medium:
                selectedBooks
                  ?.map((book) => book.medium_id)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  )
                  .join(", ") || "",
              book_type:
                selectedBooks
                  ?.map((book) => book.series_id)
                  .filter(
                    (name, index, self) => name && self.indexOf(name) === index
                  )
                  .join(", ") || "",
              tags:
                initialfields.tagsGrouping.length > 0 &&
                initialfields.tagsGrouping.map((id, index) => ({
                  id,
                  tag_name: initialfields.tagsLabel[index],
                })),
              dimension: null,
              weight: initialfields.weight || null,
              description: initialfields.description || "",
              total_pages: parseInt(initialfields.tnoPage) || 0,
              // iframe: initialfields.iframe || null,
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              ebook_url: initialfields.bookPathUrl,
              is_ebook: 0,
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              is_visible: 1,
              images: images,
              created_dt: moment().format("YYYY-MM-DD"),
              created_by: userid,
            };

            AxiosInstance.post("/api/book/add", createData)
              .then((res) => {
                if (res.data.status) {
                  toast.success(res.data.message);
                  navigate("/studyMaterials/Books/list/2");
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        toast.error("A minimum of 2 books is required to create a book set.");
      }
    } else {
      setError(errors);
    }
  };
  const Tagsitems = [
    {
      tag_id: 0,
      tag_name: "A",
    },
    {
      tag_id: 1,
      tag_name: "B",
    },
    {
      tag_id: 2,
      tag_name: "GB",
    },
    {
      tag_id: 3,
      tag_name: "QB",
    },
    {
      tag_id: 4,
      tag_name: "PYQ",
    },
    // {
    //   tag_id: 6,
    //   tag_name: "Combo Offers",
    // },
  ];
  const Tagsitems1 = [
    {
      value: "0",
      label: "A",
    },
    {
      value: "1",
      label: "B",
    },
    {
      value: "2",
      label: "GB",
    },
    {
      value: "3",
      label: "QB",
    },
    {
      value: "4",
      label: "PYQ",
    },
  ];
  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const ccategory = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setCategory(ccategory);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // useEffect(() => {
  //   // if (updateChipData?.length > 0) {
  //   loadListdata();
  //   // }
  // }, [updateChipData]);

  const handleFreeBookChange = (event) => {
    const value = Number(event.target.value);
    setFreeBook(value);
    setSelectedBooks([]);
    isFirstRender.current = false;
  };

  useEffect(() => {
    if (!isFirstRender.current) {
      loadListdata();
    }
  }, [freeBook]);

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathHeader BathDet  global_container ">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">
            {id ? "Edit Bookset" : "Create New Bookset"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Bookset" : "Back to Books"}
              </Link>
            </li>
            <li
              className={`ListBtnItems ${
                selectedBooks?.length < 2 && "disabled_btn"
              } `}
            >
              <Link
                to={"javascript:void(0)"}
                // className="primaryButton"
                className={`primaryButton ${
                  selectedBooks?.length < 2 && "disabled_btn"
                } `}
                onClick={selectedBooks?.length < 2 ? () => {} : handleSubmit}
              >
                Save Bookset
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* Individual Books table Portion */}
      <div className="row mt-3 mx-0">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
          <fieldset className={StyleInfo.CourierContainer}>
            <legend className="w-auto mb-0">Individual Books</legend>

            <div>
              <label
                htmlFor="freeBook"
                className="form-label confirm_value mx-0"
              >
                Is this a free book set?
              </label>

              <div>
                <input
                  ref={isFirstRender}
                  style={{ cursor: "pointer" }}
                  className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                  type="radio"
                  id="freeBookset_yes"
                  name="freeBook"
                  value={1}
                  checked={freeBook === 1}
                  onChange={handleFreeBookChange}
                  disabled={id}
                />
                <label
                  htmlFor="freeBookset_yes"
                  className={`${createInfo.margin_right} form-label confirm_value`}
                  style={{ verticalAlign: "unset", margin: "0" }}
                >
                  Yes
                </label>

                <input
                  ref={isFirstRender}
                  className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                  style={{ marginLeft: "10px" }}
                  type="radio"
                  handle
                  id="freeBookset_no"
                  name="freeBook"
                  value={0}
                  checked={freeBook === 0}
                  onChange={handleFreeBookChange}
                  disabled={id}
                />
                <label
                  htmlFor="freeBookset_no"
                  className="form-label confirm_value"
                  style={{ verticalAlign: "unset", margin: "0" }}
                >
                  No
                </label>
              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-3 col-12 px-0">
                <div class={StyleInfo.searchInputSec}>
                  <input
                    ref={txtBSearch}
                    className={`${StyleInfo.searchInput} w-100`}
                    type="text"
                    placeholder="Search by Book Name"
                    name="search_book_title"
                    onKeyDown={handleSearch}
                  />
                  <Search
                    onClick={handleSearchFocus}
                    className={`${StyleInfo.ListsearchIcon}`}
                  />
                </div>
              </div>
            </div>
            {updateChipData?.length > 0 ? (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      return (
                        <ListItem key={index}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={StyleInfo.BoldTyText}>
                                  {data.type === "price"
                                    ? `Price: ${data.name}`
                                    : data.name}
                                </span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0 mt-4">
              <div className="col-md-12 table-responsive tableMinHeight px-0 ">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      <th id="th" className={StyleInfo.tableThPadding}></th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className="textHead_th"
                        >
                          Book Name
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_author}
                      >
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className="textHead_th"
                        >
                          Author
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            author_name.length > 0
                              ? StyleInfo.active_icons_book
                              : ""
                          } ${
                            isOpen.author ? StyleInfo.active_icons_book : ""
                          }`} // Change here
                          onClick={(e) => handleFilter(e, "author")}
                        >
                          filter_list
                        </span>
                        {isOpen.author && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {originalListData.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.author_name}
                                        value={el.author_id}
                                        id={el.author_name}
                                        checked={author_name?.some(
                                          (element) => {
                                            if (element.id == el.author_id) {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.author_name,
                                            "author"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.author_name}
                                      >
                                        {el.author_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("author")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        author_name.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("author")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_publisher}
                      >
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className="textHead_th"
                        >
                          Publisher
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            publisher_name.length > 0
                              ? StyleInfo.active_icons_book
                              : ""
                          } ${
                            isOpen.publisher ? StyleInfo.active_icons_book : ""
                          }`} // Change here
                          onClick={(e) => handleFilter(e, "publisher")}
                        >
                          filter_list
                        </span>
                        {isOpen.publisher && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {originalListDataPub.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.publisher_name}
                                        value={el.publisher_id}
                                        id={el.publisher_name}
                                        checked={publisher_name?.some(
                                          (element) => {
                                            if (element.id == el.publisher_id) {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.publisher_name,
                                            "publisher"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.publisher_name}
                                      >
                                        {el.publisher_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("publisher")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        publisher_name.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("publisher")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_visible_to_user}
                      >
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className="textHead_th"
                          >
                            Visible <br /> to Users
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              visible_to_user.length > 0 ||
                              isOpen.visible_to_user
                                ? StyleInfo.active_icons_book
                                : ""
                            } `} // Change here
                            onClick={(e) => handleFilter(e, "visible_to_user")}
                          >
                            filter_list
                          </span>
                          {isOpen.visible_to_user && (
                            <>
                              <div className="filterBoxs_testlist mt-4">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Visible to Users : Yes"}
                                        value={"1"}
                                        checked={visible_to_user?.some(
                                          (element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"visible_to_user_Yes"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "visible_to_user",
                                            "visible_to_user"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"visible_to_user_Yes"}
                                      >
                                        Yes
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Visible to Users : No"}
                                        value={"0"}
                                        checked={visible_to_user?.some(
                                          (element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"visible_to_user_No"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "visible_to_user",
                                            "visible_to_user"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"visible_to_user_No"}
                                      >
                                        No
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("visible_to_user")
                                        }
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          visible_to_user.length === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("visible_to_user")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_category}
                      >
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            category_on.length > 0 || isOpen.category
                              ? StyleInfo.active_icons_book
                              : ""
                          } `}
                          onClick={(e) => handleFilter(e, "category")}
                        >
                          filter_list
                        </span>

                        {isOpen.category && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {categoryId.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.name}
                                        value={el.id}
                                        id={el.name}
                                        checked={category_on.some((element) => {
                                          if (element.name == el.name) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.name,
                                            "category"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.name}
                                      >
                                        {el.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("category")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        category_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("category")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* <div
                                             ref={filterRef_category}
                                             className={`${StyleInfo.overlay} ${isOpen.category ? "active" : ""
                                               }`}
                                           ></div> */}
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_course}
                      >
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className="textHead_th"
                        >
                          Course
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            course_on.length > 0 || isOpen.course
                              ? StyleInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "course")}
                        >
                          filter_list
                        </span>
                        {isOpen.course && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${StyleInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${StyleInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by course"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "course")
                                      }
                                      ref={txtBSearch_course}
                                    />
                                    <Search
                                      onClick={(e) =>
                                        handleFilterSearchFocus("course")
                                      }
                                      className={`${StyleInfo.ListsearchIcon}`}
                                    />
                                  </li>

                                  {uniqueCourse.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.course_name}
                                        value={el.course_id}
                                        id={el.course_name}
                                        checked={course_on.some((element) => {
                                          if (element.id == el.course_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.course_name,
                                            "course"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.course_name}
                                      >
                                        {el.course_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("course")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        course_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("course")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* <div
                        ref={filterRef_course}
                        className={`${StyleInfo.overlayBookFilter} ${isOpen.course ? "active" : ""
                          }`}
                      ></div> */}
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_subject}
                      >
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className="textHead_th"
                        >
                          Subject
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            subject_on.length > 0 || isOpen.subject
                              ? StyleInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "subject")}
                        >
                          filter_list
                        </span>
                        {isOpen.subject && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${StyleInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${StyleInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by subject"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "subject")
                                      }
                                      ref={txtBSearch_sub}
                                    />
                                    <Search
                                      onClick={() =>
                                        handleFilterSearchFocus("subject")
                                      }
                                      className={`${StyleInfo.ListsearchIcon}`}
                                    />
                                  </li>
                                  {uniqueSubject.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.subject_name}
                                        value={el.subject_id}
                                        id={el.subject_name}
                                        checked={subject_on?.some((element) => {
                                          if (element.id == el.subject_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.subject_name,
                                            "subject"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.subject_name}
                                      >
                                        {el.subject_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("subject")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        subject_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("subject")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* <div
                              ref={filterRef_subject}
                              className={`${StyleInfo.overlayBookFilter} ${isOpen.subject ? "active" : ""
                                }`}
                            ></div> */}
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_medium}
                      >
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            medium_on.length > 0 || isOpen.medium
                              ? StyleInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "medium")}
                        >
                          filter_list
                        </span>
                        {isOpen.medium && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Tamil"}
                                      value={"0"}
                                      checked={medium_on?.some((element) => {
                                        if (element.id == "0") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_tamil"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_tamil"}
                                    >
                                      Tamil
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"English"}
                                      value={"1"}
                                      checked={medium_on?.some((element) => {
                                        if (element.id == "1") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_english"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_english"}
                                    >
                                      English
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Both"}
                                      value={"2"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "2") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Both"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Both"}
                                    >
                                      Both
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("medium")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        medium_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("medium")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_series}
                      >
                        <span
                          className="textHead_th"
                          onClick={(e) => handleSort(e, "seriesTag")}
                        >
                          Book Series
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "seriesTag")}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            series_on.length > 0 || isOpen.seriesTag
                              ? StyleInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "seriesTag")}
                        >
                          filter_list
                        </span>
                        {isOpen.seriesTag && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {Tagsitems.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.tag_name}
                                        value={el.tag_id}
                                        id={el.tag_name}
                                        checked={series_on.some((element) => {
                                          if (element.id == el.tag_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.tag_name,
                                            "seriesTag"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.tag_name}
                                      >
                                        {el.tag_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("seriesTag")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        series_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("seriesTag")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* <div
                                              ref={filterRef_medium}
                                              className={`${StyleInfo.overlayBookFilter} ${isOpen.medium ? "active" : ""
                                                }`}
                                            ></div> */}
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_mrp}
                      >
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className="textHead_th"
                        >
                          MRP
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            mrp.fromDate || mrp.toDate || isOpen.price
                              ? StyleInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "price")}
                        >
                          filter_list
                        </span>
                        {isOpen.price === true && (
                          <div className="filterBoxs p-1 mt-3">
                            <div className="row ">
                              <div className="col-md-12">
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      From
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="fromDate"
                                    name="fromDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the from price"
                                    value={mrp.fromDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      To
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="toDate"
                                    name="toDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the to price"
                                    value={mrp.toDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                {/* <div class="form-check">
                                                    <MultiRangeSlider
                                                      handleChangeFilter={handleChangeFilter}
                                                      ranges={ranges}
                                                    />
                                                  </div> */}
                              </div>
                            </div>
                            <hr />
                            <div className="row mt-3">
                              <div className="col-md-4  col-4 col-sm-4">
                                <span
                                  className="clearFilter ms-2 "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClear("price")}
                                >
                                  Clear
                                </span>
                              </div>
                              <div className="col-md-8  col-8 col-sm-8">
                                <button
                                  className="FilterButton"
                                  onClick={() => handleApplyFilter("price")}
                                >
                                  Apply Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className="textHead_th"
                        >
                          Offer %
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className="textHead_th"
                          >
                            Final
                            <br /> Price
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>{" "}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "stock_count")}
                            className="textHead_th"
                          >
                            Stock
                            <br /> Count
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "stock_count")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentData?.map((book) => (
                        <tr
                          key={book.id}
                          className={
                            book.stock_count < 0 ? StyleInfo.redRow : ""
                          }
                        >
                          <td>
                            <input
                              className={`${StyleInfo.checkBox_input}  
                              ${
                                book.is_visible === 0 ||
                                (book.is_ebook === 0 && book.stock_count === 0)
                                  ? "disabled_btn"
                                  : ""
                              } `}
                              type="checkbox"
                              name="bookset_order"
                              id={`bookset_order_${book.id}`}
                              value={book.id}
                              checked={
                                Array.isArray(selectedBooks) &&
                                selectedBooks.some((b) => b.id === book.id)
                              }
                              disabled={
                                book.is_visible === 0 ||
                                (book.is_ebook === 0 && book.stock_count === 0)
                              }
                              // Reflect selection
                              // onChange={(e) => {
                              //   if (book.stock_count <= 0) {
                              //     // Show a toast message for out-of-stock items
                              //     toast.error(
                              //       `Cannot select "${book.book_title}" Out of stock!`
                              //     );
                              //     return; // Prevent further execution
                              //   }
                              //   handleChangeBookOrder(e, book.id); // Update state
                              // }}
                              onChange={(e) =>
                                handleChangeBookOrder(e, book.id)
                              }
                            />
                          </td>
                          <td>{book.serialNumber}</td>
                          <td id="td">
                            <span
                              title={book.book_title}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.book_title}
                            </span>
                          </td>
                          <td id="td">
                            {" "}
                            <span
                              title={book.author}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.author ? book.author : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.publisher}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.publisher ? book.publisher : "_"}
                            </span>
                          </td>
                          <td id="td">{book.is_visible ? "Yes" : "No"}</td>
                          <td id="td">
                            {book.category_name ? book.category_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={book.group_course_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.subject_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.subject_name ? book.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{book.medium ? book.medium : "_"}</td>
                          <td id="td">{book.series_name || "_"}</td>
                          <td id="td">{book.price ? book.price : "0"}</td>
                          <td id="td">
                            {book.offer_percentage
                              ? book.offer_percentage
                              : "0"}
                          </td>
                          <td id="td">
                            {book.finalPrice ? book.finalPrice : "0"}
                          </td>
                          <td id="td">
                            {book.stock_count == 0
                              ? book.stock_count
                              : book.stock_count || "_"}
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={StyleInfo.cursor_pointer}
                              alt="view icon"
                              onClick={(e) => handleView(book.id)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages == 0}
              />
            </div>
          </fieldset>
        </div>
      </div>
      {/* Book in this set */}
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={StyleInfo.CourierContainer}>
            <legend className="w-auto mb-0">Books in this Set</legend>
            <div className="row mx-0 mt-4">
              <div className="col-md-12 table-responsive tableMinHeight px-0">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      {/* <th id="th" className={StyleInfo.tableThPadding}></th> */}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "seriesNumber")}
                        >
                          S.No.
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "seriesNumber")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "book_title")}
                        >
                          Book Name
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "book_title")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "author")}
                        >
                          Author
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "author")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "publisher")}
                        >
                          Publisher
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "publisher")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) => SortSelectedBooks(e, "is_visible")}
                          >
                            {" "}
                            Visible <br /> to Users
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => SortSelectedBooks(e, "is_visible")}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "category_name")}
                        >
                          Category
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "category_name")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooks(e, "group_course_name")
                          }
                        >
                          Course
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooks(e, "group_course_name")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "subject_name")}
                        >
                          Subject
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "subject_name")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "medium")}
                        >
                          Medium
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "medium")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "price")}
                        >
                          MRP
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "price")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooks(e, "offer_percentage")
                          }
                        >
                          Offer %
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooks(e, "offer_percentage")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) => SortSelectedBooks(e, "finalPrice")}
                          >
                            {" "}
                            Final
                            <br /> Price
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => SortSelectedBooks(e, "finalPrice")}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) => SortSelectedBooks(e, "stock_count")}
                          >
                            {" "}
                            Stock
                            <br /> Count
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => SortSelectedBooks(e, "stock_count")}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedBooks?.length === 0 ? (
                      <tr>
                        <td colSpan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      Array.isArray(paginatedBooks) &&
                      paginatedBooks?.map((book, index) => (
                        <tr
                          key={book.id}
                          className={
                            book.stock_count < 0 ? StyleInfo.redRow : ""
                          }
                        >
                          {/* <td>{index + 1}</td>
                          <td>{book.name}</td>
                          <td>{book.author}</td>
                          <td>{book.publisher}</td>
                          <td>{book.mrp}</td>
                          <td>{book.offer}</td>
                          <td>{book.finalPrice}</td>
                          <td>{book.stockCount}</td>
                          <td>{book.visible ? "Yes" : "No"}</td>
                          <td>{book.category}</td>
                          <td>{book.course}</td>
                          <td>{book.subject}</td>
                          <td>{book.medium}</td>
                          <td id="td">
                            <img src={ViewIcon} alt="view icon" />
                          </td> */}
                          {/* <td id="td">{book.serialNumber}</td> */}
                          <td id="td">{book.seriesNumber}</td>
                          <td id="td">
                            <span
                              title={book.book_title}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.book_title}
                            </span>
                          </td>
                          <td id="td">
                            {" "}
                            <span
                              title={book.author}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.author ? book.author : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.publisher}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.publisher ? book.publisher : "_"}
                            </span>
                          </td>
                          <td id="td">{book.is_visible ? "Yes" : "No"}</td>
                          <td id="td">
                            {book.category_name ? book.category_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={book.group_course_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.subject_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.subject_name ? book.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{book.medium ? book.medium : "_"}</td>
                          <td id="td">{book.price ? book.price : "0"}</td>
                          <td id="td">
                            {book.offer_percentage
                              ? book.offer_percentage
                              : "0"}
                          </td>
                          <td id="td">
                            {book.finalPrice ? book.finalPrice : "0"}
                          </td>
                          <td id="td">
                            {book.stock_count ? book.stock_count : "_"}
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={StyleInfo.cursor_pointer}
                              alt="view icon"
                              onClick={(e) => handleView(book.id)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPageTwo}
                handlePageCount={handlePageCountTwo}
                startPage={selectedBooks?.length > 0 ? startIndex + 1 : 0}
                endPage={
                  selectedBooks?.length > 0
                    ? Math.min(endIndex, selectedBooks?.length)
                    : 0
                }
                totalRecords={selectedBooks?.length}
                handlePrev={handlePrevTwo}
                currentPrevPage={currentPageTwo === 1}
                prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                handleNext={handleNextTwo}
                currentNextPage={
                  currentPageTwo >= totalPagesTwo || totalPages == 0
                }
              />
            </div>
          </fieldset>
        </div>
      </div>
      {/* <BookSetDetails /> */}
      <div className="row mt-3">
        {/* bookname details */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={BookSetInfo.CourierContainer}>
            <legend className="w-auto mb-0">Bookset Details</legend>
            <form className="row g-3">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column mb-3">
                <label for="book_title" class="form-label confirm_value ">
                  Bookset Name
                </label>
                <input
                  ref={bookset_name_ref}
                  // className={`${BookSetInfo.textInputBox}`}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="book_title"
                  name="book_title"
                  placeholder="Enter the bookset name"
                  value={initialfields.book_title}
                  onChange={handleChange}
                />
                {error.book_title && (
                  <small className="error_message">{error.book_title}</small>
                )}
              </div>

              {id && (
                <div className="col-md-6">
                  <label htmlFor="visible" className="form-label confirm_value">
                    Visible to Users
                  </label>

                  <div>
                    <input
                      ref={visible_ref}
                      className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                      // isDisabled={id ? true : false}
                      // disabled={!!id}
                      type="radio"
                      checked={initialfields.visible == 1 ? true : false}
                      id="yes"
                      name="visible"
                      value={1}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="yes"
                      className={`${createInfo.margin_right} form-label confirm_value`}
                    >
                      Yes
                    </label>

                    <input
                      ref={visible_ref}
                      className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                      //  isDisabled={id ? true : false}
                      // disabled={!!id}
                      type="radio"
                      id="no"
                      name="visible"
                      value={0}
                      checked={initialfields.visible == 0 ? true : false}
                      onChange={handleChange}
                    />
                    <label htmlFor="no" className="form-label confirm_value">
                      No
                    </label>
                  </div>
                </div>
              )}
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label for="iframe" class="form-label confirm_value ">
                  YouTube URL
                </label>
                <input
                  ref={youtube_ref}
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  type="text"
                  id="iframe"
                  name="iframe"
                  placeholder="Enter YouTube URL"
                  value={initialfields.iframe || ""}
                  onChange={handleIframeChange}
                />
                {error.iframe && (
                  <small className="error_message">{error.iframe}</small>
                )}
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column mb-3">
                <label for="book_title" class="form-label confirm_value ">
                  Short Description
                </label>
                <input
                  // className={`${BookSetInfo.textInputBox}`}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="tagLine"
                  name="tagLine"
                  maxLength={50}
                  placeholder="Enter the short description (maximum 50 characters allowed)"
                  value={initialfields.tagLine}
                  onChange={handleChange}
                />
                {error.tagLine && (
                  <small className="error_message">{error.tagLine}</small>
                )}
              </div>
              <div class="col-md-6">
                <label for="isbnNumber" class="form-label confirm_value ">
                  ISBN Number
                </label>
                <input
                  ref={isbn_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="isbnNumber"
                  name="isbnNumber"
                  placeholder="Enter ISBN number"
                  value={initialfields.isbnNumber}
                  onChange={handleChange}
                />
                {error.isbnNumber && (
                  <small className="error_message">{error.isbnNumber}</small>
                )}
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="is_combo_offer"
                  className="form-label confirm_value mx-0"
                >
                  Is this a combo offer?
                </label>

                <div>
                  <input
                    // ref={ebook_ref}
                    className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                    // isDisabled={id ? true : false}
                    // disabled={!!id}
                    type="radio"
                    checked={initialfields.is_combo_offer == 1 ? true : false}
                    id="yes"
                    name="is_combo_offer"
                    value={1}
                    onChange={(e) => {
                      handleChange(e);
                      setInitialfields((prevFields) => ({
                        ...prevFields,
                        offer_percentage: "",
                      }));
                    }}
                  />
                  <label
                    htmlFor="yes"
                    className={`${createInfo.margin_right} form-label confirm_value`}
                    style={{ verticalAlign: "unset", margin: "0" }}
                  >
                    Yes
                  </label>

                  <input
                    // ref={ebook_ref}
                    className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                    //  isDisabled={id ? true : false}
                    // disabled={!!id}
                    style={{ marginLeft: "10px" }}
                    type="radio"
                    id="no"
                    name="is_combo_offer"
                    value={0}
                    checked={initialfields.is_combo_offer == 0 ? true : false}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="no"
                    className="form-label confirm_value"
                    style={{ verticalAlign: "unset", margin: "0" }}
                  >
                    No
                  </label>
                </div>
                {error.is_combo_offer && (
                  <small className="error_message">
                    {error.is_combo_offer}
                  </small>
                )}
              </div>
            </form>
            <div className="row mx-0 mt-3">
              <div class="col-12 d-flex flex-column px-0">
                <label for="description" class="form-label confirm_value ">
                Detailed Description
                </label>
                <textarea
                  ref={description_ref}
                  className={`${BookSetInfo.desc_input} w-100 rounded p-2 input-font-size`}
                  placeholder="Enter description here (maximum 1500 characters allowed)"
                  id="description"
                  onChange={handleChange}
                  value={initialfields.description}
                  name="description"
                  maxLength={1500}
                  rows="4"
                ></textarea>
                {error.description && (
                  <span className="error_message">{error.description}</span>
                )}
              </div>
            </div>
          </fieldset>
        </div>
        {/* price set portion */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3">
          <fieldset className={BookSetInfo.CourierContainer}>
            <legend className="w-auto mb-0">Price</legend>
            <form className="row g-3">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label
                  for="CourseName"
                  class="form-label confirm_value disabled_btn"
                >
                  MRP
                </label>
                <input
                  // className={`${BookSetInfo.textInputBox} disabled_btn`}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm disabled_btn`}
                  type="text"
                  id="book_title"
                  name="book_title"
                  placeholder="Enter the mrp"
                  value={initialfields.price}
                  disabled
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label for="offer_percentage" class="form-label confirm_value ">
                  Offer Percentage
                </label>
                <input
                  ref={offerPer_ref}
                  // className={`${BookSetInfo.textInputBox}`}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  type="text"
                  id="offer_percentage"
                  name="offer_percentage"
                  placeholder="Enter offer percentage"
                  value={
                    initialfields.offer_percentage >= 0 &&
                    initialfields.offer_percentage <= 99
                      ? initialfields.offer_percentage
                      : ""
                  }
                  onChange={handleChange}
                  disabled={freeBook === 1}
                />
                {error.offer_percentage && (
                  <small className="error_message">
                    {error.offer_percentage}
                  </small>
                )}
              </div>
            </form>
          </fieldset>
        </div>
        {/* Course Details */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3">
          <fieldset className={BookSetInfo.CourierContainer}>
            <legend className="w-auto mb-0">Course Details</legend>
            {/* <div className="row mx-0 ">
              <div className="px-0 col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {paginatedBooks
                      ?.map(book => book.category_name)
                      .filter((name, index, self) => name && self.indexOf(name) === index)
                      .join(", ") || "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {paginatedBooks
                      ?.map(book => book.group_course_name)
                      .filter((name, index, self) => name && self.indexOf(name) === index)
                      .join(", ") || "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Subject</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {paginatedBooks
                      ?.map(book => book.subject_name)
                      .filter((name, index, self) => name && self.indexOf(name) === index)
                      .join(", ") || "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Medium</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {paginatedBooks
                      ?.map(book => book.medium)
                      .filter((name, index, self) => name && self.indexOf(name) === index)
                      .join(", ") || "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Book Series</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {paginatedBooks
                      ?.map(book => book.medium)
                      .filter((name, index, self) => name && self.indexOf(name) === index)
                      .join(", ") || "_"}
                  </p>
                </div>
              </div>
            </div> */}
            <form className="row g-3">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label for="CourseName" class=" m-0 p-0 confirm_value  ">
                  Category
                </label>
                <p className="confirm_label my-1 m-0 p-0">
                  {selectedBooks
                    ?.map((book) => book.category_name)
                    .filter(
                      (name, index, self) =>
                        name && self.indexOf(name) === index
                    ) // removes null/empty only
                    .join(", ") || "_"}
                </p>
                {/* <Select
                  ref={category_ref}
                  className={`shadow-none input-font-size `}
                  name="categoryGrouping"
                  isClearable={true}
                  value={
                    initialfields.CategoryTypeLabel &&
                      initialfields.categoryGrouping
                      ? {
                        value: initialfields.categoryGrouping,
                        label: initialfields.CategoryTypeLabel,
                      }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "categoryGrouping")
                  }
                  options={category}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select category"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } 
                  styles={customStyles} 
                /> */}
                {error.categoryGrouping && (
                  <small className="error_message">
                    {error.categoryGrouping}
                  </small>
                )}
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label for="courseGrouping" class="m-0 p-0 confirm_value ">
                  Course
                </label>
                <p className="confirm_label my-1 m-0 p-0">
                  {selectedBooks
                    ?.map((book) => book.group_course_name)
                    .filter(Boolean)
                    .join(", ") || "_"}
                </p>
                {/* <Select
                  ref={course_ref}
                  className={`shadow-none input-font-size `}
                  name="courseGrouping"
                  isClearable={true}
                  value={
                    initialfields.CourseTypeLabel &&
                      initialfields.courseGrouping
                      ? {
                        value: initialfields.courseGrouping,
                        label: initialfields.CourseTypeLabel,
                      }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "courseGrouping")
                  }
                  options={groupName}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select course"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                /> */}
                {error.courseGrouping && (
                  <small className="error_message">
                    {error.courseGrouping}
                  </small>
                )}
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column mt-3">
                <label for="subjectGrouping" class="m-0 p-0 confirm_value ">
                  Subject
                </label>
                <p className="confirm_label my-1 m-0 p-0">
                  {selectedBooks
                    ?.map((book) => book.subject_name)
                    .filter(Boolean)
                    .join(", ") || "_"}
                </p>
                {/* <Select
                  ref={subject_ref}
                  className={`shadow-none input-font-size `}
                  name="subjectGrouping"
                  isClearable={true}
                  value={
                    initialfields.subjectTypeLabel &&
                      initialfields.subjectGrouping
                      ? {
                        value: initialfields.subjectGrouping,
                        label: initialfields.subjectTypeLabel,
                      }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "subjectGrouping")
                  }
                  options={subjectGroupName}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select subject"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option?.label
                      ?.toLowerCase()
                      ?.includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                /> */}
                {error.subjectGrouping && (
                  <small className="error_message">
                    {error.subjectGrouping}
                  </small>
                )}
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column mt-3">
                <label for="CourseName" class="m-0 p-0 confirm_value ">
                  Medium
                </label>
                <p className="confirm_label my-1 m-0 p-0">
                  {selectedBooks
                    ?.map((book) => book.medium)
                    .filter(
                      (name, index, self) =>
                        name && self.indexOf(name) === index
                    )
                    .join(", ") || "_"}
                </p>
                {/* <Select
                  ref={medium_ref}
                  className={`shadow-none input-font-size`}
                  name="mediumGrouping"
                  isClearable={true}
                  value={
                    initialfields.mediumGrouping !== undefined &&
                      initialfields.mediumTypeLabel
                      ? {
                        value: initialfields.mediumGrouping,
                        label: initialfields.mediumTypeLabel,
                      }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "mediumGrouping")
                  }
                  options={[
                    { value: 0, label: "Tamil" },
                    { value: 1, label: "English" },
                    { value: 2, label: "Both" },
                  ]}
                  isSearchable={true}
                  placeholder="Select medium"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                /> */}
                {error.mediumGrouping && (
                  <small className="error_message">
                    {error.mediumGrouping}
                  </small>
                )}
              </div>
              <div className="col-md-6">
                <label for="seriesTag" class="m-0 p-0 confirm_value ">
                  Book Series
                </label>
                <p className="confirm_label my-1 m-0 p-0">
                  {selectedBooks
                    ?.map((book) => book.series_name)
                    .filter(
                      (name, index, self) =>
                        name && self.indexOf(name) === index
                    )
                    .join(", ") || "_"}
                </p>
                {/* <Select
                  ref={seriesTag_ref}
                  className={`shadow-none input-font-size `}
                  name="seriesGrouping"
                  // isClearable={true}
                  value={
                    initialfields.seriesGrouping !== "" &&
                      initialfields.seriesGrouping !== undefined
                      ? {
                        value: initialfields.seriesGrouping,
                        label: initialfields.seriesTypeLabel,
                      }
                      : ""
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "seriesGrouping")
                  }
                  options={Tagsitems1}
                  // isSearchable={true}
                  placeholder="Select series"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      ?.toLowerCase()
                      .includes(searchText?.toLowerCase())
                  }
                  styles={customStyles}
                /> */}
                {error.seriesGrouping && (
                  <small className="error_message">
                    {error.seriesGrouping}
                  </small>
                )}
              </div>
            </form>
          </fieldset>
        </div>
        {/* weight set portion */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3">
          <fieldset className={BookSetInfo.CourierContainer}>
            <legend className="w-auto mb-0">Weight</legend>
            <form className="row g-3">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label
                  for="CourseName"
                  class="form-label confirm_value disabled_btn"
                >
                  Weight (in kg)
                </label>
                <input
                  // className={`${BookSetInfo.textInputBox} disabled_btn`}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm disabled_btn`}
                  type="text"
                  id="book_name"
                  name="book_name"
                  disabled
                  placeholder="weight"
                  value={initialfields.weight}
                />
              </div>
            </form>
          </fieldset>
        </div>
        {/* Tags */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3">
          <fieldset className={BookSetInfo.CourierContainer}>
            <legend className="w-auto mb-0">Tags</legend>
            <form className="row g-3" onSubmit={(e) => e.preventDefault()}>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column">
                <label for="tagsGrouping" class="form-label confirm_value ">
                  Tags (Maximum 8 tags allowed)
                </label>
                <Creatable
                  ref={tagsGrouping_ref}
                  name="tagsGrouping"
                  isMulti
                  value={
                    initialfields.tagsGrouping && initialfields.tagsLabel
                      ? initialfields.tagsGrouping.map((value, index) => ({
                          value: value,
                          label: initialfields.tagsLabel[index],
                        }))
                      : null
                  }
                  onChange={(selectedOptions) =>
                    handlechangeSelectDropdown(selectedOptions, "tagsGrouping")
                  }
                  options={tagsList}
                  isSearchable={true}
                  placeholder="Select or enter new tags"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                  formatCreateLabel={(inputValue) => `Add New: ${inputValue}`}
                />
                {error.tagsGrouping && (
                  <small className="error_message">{error.tagsGrouping}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>
        {/* Upload Images */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Upload Images</legend>
            <form className="row g-3">
              <div className="col-lg-6 col-md-6">
                <div className="d-flex">
                  <div className="row">
                    <div className="d-flex">
                      <label
                        htmlFor="uploadPrevImage"
                        className="form-label confirm_value"
                      >
                        Upload Images (Max 4, 2MB each, JPG/PNG format)
                      </label>
                    </div>
                  </div>
                </div>

                <input
                  ref={upload_image_ref}
                  name="uploadPrevImage"
                  type="file"
                  className="InputsSelectFile"
                  multiple
                  accept="image/*"
                  onChange={handleChange}
                  disabled={
                    initialfields.upload_image_path?.filter(
                      (image) => image?.is_valid !== 0
                    ).length >= 4
                  }
                />
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    // flexWrap: "wrap",
                    position: "relative",
                  }}
                >
                  {initialfields.upload_image_path?.length > 0 &&
                    initialfields.upload_image_path.map((image, index) =>
                      image?.is_valid !== 0 ? (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            marginTop: "10px",
                          }}
                        >
                          <img
                            className={createInfo.multiImage}
                            src={`${baseURL}/${
                              typeof image === "string" ? image : image?.path
                            }`}
                            alt={`Preview ${index + 1}`}
                            style={{
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              margin: "5px",
                            }}
                          />
                          <button
                            onClick={(e) => handleDeleteImg(e, index)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "0",
                              left: "90%",
                              background: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ) : null
                    )}
                </div>

                {error.upload_image_path && (
                  <span className="error_message">
                    {error.upload_image_path}
                  </span>
                )}
              </div>
            </form>
          </fieldset>
        </div>
      </div>
      {/* last submit button */}
      <div className="row mt-3 mb-4 mx-0">
        <div className="col-md-12 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Bookset" : "Back to Books"}
              </Link>
            </li>
            <li
              className={`ListBtnItems ${
                selectedBooks.length < 2 && "disabled_btn"
              } `}
            >
              <Link
                to={"javascript:void(0)"}
                // className="primaryButton"
                className={`primaryButton ${
                  selectedBooks.length < 2 && "disabled_btn"
                } `}
                onClick={selectedBooks.length < 2 ? () => {} : handleSubmit}
              >
                Save Bookset
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
